import { useSms } from '../store/sms';

export function SmsBadge(): JSX.Element | null {
  const total = useSms((s) => s.unreadTotal);
  if (total === 0) return null;
  return (
    <span className="inline-flex items-center justify-center h-5 min-w-[20px] px-1 rounded-full bg-brand-600 text-white text-xs font-semibold">
      {total > 99 ? '99+' : total}
    </span>
  );
}
